import { useAppKit } from '@reown/appkit/react'

export interface UseConnectModalResult {
  openConnectModal: () => void
}

export function useConnectModal(): UseConnectModalResult {
  if (import.meta.env.VITE_ENV_NAME === 'test' || import.meta.env.VITE_PLAYWRIGHT === '1') {
    return {
      openConnectModal: () => {},
    }
  }

  // biome-ignore lint/correctness/useHookAtTopLevel: above check is static
  const { open } = useAppKit()
  return {
    openConnectModal: () => open({ view: 'Connect' }),
  }
}

export interface UseChainModalResult {
  openChainModal: () => void
}

export function useChainModal(): UseChainModalResult {
  if (import.meta.env.VITE_ENV_NAME === 'test' || import.meta.env.VITE_PLAYWRIGHT === '1') {
    return {
      openChainModal: () => {},
    }
  }

  // biome-ignore lint/correctness/useHookAtTopLevel: above check is static
  const { open } = useAppKit()
  return {
    openChainModal: () => open({ view: 'Networks' }),
  }
}
